import idMonitorAnalyticsBlue from '../../../images/id-monitor-analytics-blue.svg';
import idMonitorCalculatorBlue from '../../../images/id-monitor-calculator-blue.svg';
import idMonitorContactPageBlue from '../../../images/id-monitor-contact-page-blue.svg';
import idMonitorFeedBlue from '../../../images/id-monitor-feed-blue.svg';
import idMonitorNavigatorBlue from '../../../images/id-monitor-navigator-blue.svg';
import idMonitorShieldBlue from '../../../images/id-monitor-shield-blue.svg';

// Blue versions of the icons

export interface GetStartedSummaryDetailsProps {
  img: string;
  title: string;
  summary: string;
}

// Blue versions of the images
const blueImages = {
  contactPage: idMonitorContactPageBlue,
  shield: idMonitorShieldBlue,
  analytics: idMonitorAnalyticsBlue,
  calculator: idMonitorCalculatorBlue,
  feed: idMonitorFeedBlue,
  navigator: idMonitorNavigatorBlue,
};

export const getImage = (key: keyof typeof blueImages): string => {
  return blueImages[key];
};

export const getSummaries = (): GetStartedSummaryDetailsProps[] => [
  {
    img: getImage('contactPage'),
    title: 'Identity & Credit Monitoring',
    summary:
      'Safeguard your identity and credit with alerts monitoring changes in your TransUnion credit record',
  },
  {
    img: getImage('shield'),
    title: '$1M Identity Theft Insurance & Restoration',
    summary:
      'Recover certain out-of-pocket expenses and lost wages if your identity is stolen',
  },
  {
    img: getImage('analytics'),
    title: 'Score Tracker',
    summary:
      'Keep a monthly historical record of your credit score to monitor your progress',
  },
  {
    img: getImage('calculator'),
    title: 'Score Simulator',
    summary:
      'See how your next financial decision may impact your credit profile',
  },
  {
    img: getImage('feed'),
    title: 'Credit Summary',
    summary:
      "Don't have time to look over your entire credit report? Access the highlights with Quick Summary",
  },
  {
    img: getImage('navigator'),
    title: 'Credit Navigator',
    summary:
      'Get analysis on factors and actions that may help accomplish your credit goals',
  },
];

export const summaries = getSummaries();
